import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  articleData?: {
    publishedTime?: string;
    modifiedTime?: string;
    author?: string;
    tags?: string[];
  };
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  articleData,
}: SEOHeadProps) {
  useEffect(() => {
    const fullTitle = title.includes('开体育在线') ? title : `${title} - 开体育在线`;
    document.title = fullTitle;

    const setMeta = (name: string, content: string, property = false) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);

    setMeta('og:title', fullTitle, true);
    setMeta('og:description', description, true);
    setMeta('og:type', ogType, true);
    if (canonicalUrl) {
      setMeta('og:url', canonicalUrl, true);
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'canonical';
        document.head.appendChild(link);
      }
      link.href = canonicalUrl;
    }

    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', description);

    if (articleData) {
      if (articleData.publishedTime) setMeta('article:published_time', articleData.publishedTime, true);
      if (articleData.modifiedTime) setMeta('article:modified_time', articleData.modifiedTime, true);
      if (articleData.author) setMeta('article:author', articleData.author, true);
      if (articleData.tags) {
        articleData.tags.forEach((tag) => {
          const tagEl = document.createElement('meta');
          tagEl.setAttribute('property', 'article:tag');
          tagEl.setAttribute('content', tag);
          document.head.appendChild(tagEl);
        });
      }
    }

    return () => {
      document.querySelectorAll('meta[property="article:tag"]').forEach((el) => el.remove());
    };
  }, [title, description, keywords, canonicalUrl, ogType, articleData]);

  return null;
}